import React from "react";
import CrudEditor from "./admin/CrudEditor";

export default function AdminJobs() {
  return (
    <CrudEditor
      title="Job Posts"
      subtitle="Manage careers page listings."
      endpoint="/jobs"
      testKey="jobs"
      emptyItem={{ title: "", department: "", location: "", employment_type: "Full-time", experience: "", description: "", requirements: [], is_active: true }}
      fields={[
        { key: "title", label: "Role title", type: "text" },
        { key: "department", label: "Department", type: "text" },
        { key: "location", label: "Location", type: "text" },
        { key: "employment_type", label: "Employment type", type: "text" },
        { key: "experience", label: "Experience", type: "text" },
        { key: "description", label: "Description", type: "textarea" },
        { key: "requirements", label: "Requirements (one per line)", type: "list" },
        { key: "is_active", label: "Show on careers page", type: "bool" },
      ]}
    />
  );
}
